// extracted by mini-css-extract-plugin
export default {"seachBox":"dTo2xqh1DASK58H9V8i8","searchHolder":"GmoMA09K5_JoNygglkwz","searchGlass":"iQ6SGdd7uizBFctxTa0D"};